import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';


const initialState: IMdbError | null = null;

export const sharingRequestAcceptanceFailureSlice = createSlice({
  name: 'sharingRequestAcceptanceFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    sharingRequestAcceptanceFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    sharingRequestAcceptanceFailureClear(state) {
      return null; // action.payload;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { sharingRequestAcceptanceFailureChange, sharingRequestAcceptanceFailureClear } = sharingRequestAcceptanceFailureSlice.actions;

// export the core reducer for the slice
export const sharingRequestAcceptanceFailureReducer = sharingRequestAcceptanceFailureSlice.reducer;

export default sharingRequestAcceptanceFailureSlice.reducer;